import productJson from "../_json/product";
import categoryJson from "../_json/category";
import Document from "./doc";
import Product from "./product";
import Cart from "./cart";
import ClickEvent from "./clickEvent";
import BlocksDoc from "./blocks";
import Schema from "./schema";
import Assets from "./assets";

export default function Doc() {
  return (
    <main>
      <section className='blogDetailContent fewClickSctn commonPadding'>
        <div className="container">
          <div className="row row-reverse">
            <div className="col-md-3">
              <div className="sticky">
                <div className="card">
                  <div className="card-body">
                    <h5 className="mb-2">Table of Contents</h5>
                    <ul>
                      <li><a href="#doc">Helper Functions</a></li>
                      <li><a href="#schema">Schema</a></li>
                      <li>
                        <a href="#json">JSON</a>
                        <ul className="ms-2 mb-1">
                          <li className="m-0 mb-1"><a href="#products">Products</a></li>
                          <li className="m-0"><a href="#cart">Cart</a></li>
                        </ul>
                      </li>
                      <li><a href="#blocks">Blocks in Sections</a></li>
                      <li><a href="#click-event">Click Event Handler</a></li>
                      <li><a href="#assets">Assets & Script</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="markdown prose max-w-none mb-5">
                <h3 className="text-xl font-semibold mb-2">🧩 TailwindCSS</h3>
                <p>
                  This project uses <strong>TailwindCSS v3.4.17</strong> for styling and layout utilities.
                </p>
                <p>
                  TailwindCSS provides low-level utility classes that make it easy to build responsive,
                  themeable UI components directly within your markup. It’s used here to handle
                  overlay transitions, scroll locking, and general layout styling.
                </p>
                <p>
                  📘 <a
                    href="https://v3.tailwindcss.com/docs/container"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Official TailwindCSS v3 Documentation
                  </a>
                </p>
              </div>
              <hr />

              <Document />
              <hr />
              <Schema />
              <hr />
              <div id='json' className='my-5'>
                {/* Working with JSON / Debugging Data */}
                <h3>🧠 <strong>Viewing Backend JSON Data</strong></h3>
                <p>
                  When your backend passes complex data (like arrays or objects) to Handlebars templates,
                  you can easily inspect or visualize that data using the built-in helpers or the custom
                  <code>showJson</code> helper.
                </p>

                <Product />
                <hr />
                <Cart />
                <hr />
                <BlocksDoc />
                <hr />
                <ClickEvent />

              </div>
              <hr />
              <Assets />
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
